import {
	Component,
	Input,
	ViewEncapsulation,
	OnChanges,
	SimpleChanges,
	EventEmitter,
	Output,
	ViewChild,
} from '@angular/core';
import { FormioComponent } from 'dp-formio';
declare var $: any;

@Component({
	selector: 'app-form-by-key',
	templateUrl: './form-by-key.component.html',
	// styleUrls: ['./form-by-key.component.scss']
	encapsulation: ViewEncapsulation.None,
})
export class FormByKeyComponent {
	@ViewChild(FormioComponent) formComponent: FormioComponent;

	@Input() formKey: string;
	@Input() submission: any;
	@Input() readOnly: boolean;
	@Input() viewOnly: boolean = false;
	@Input() enableFormSubmit: boolean;
	@Input() disableFields: string;
	@Output() onSubmit = new EventEmitter<any>();
	@Output() onChange = new EventEmitter<any>();
	@Output() onFormLoad = new EventEmitter<any>();
	@Output() onCustomEvent = new EventEmitter<{ type: string; data: any, formComponent: FormioComponent }>();
	@Output() onBeforeSubmit = new EventEmitter<any>();

	constructor() { }

	formLoad(formSettings) {
		if (!this.enableFormSubmit || this.readOnly || this.viewOnly)
			setTimeout(() => {
				const array = $(
					`.app-form-by-key [name="data[submit]"],.app-form-by-key [name="data[save]"]`
				);
				for (let index = 0; index < array.length; index++) {
					$(array[index]).hide();
				}
			}, 250);

		if (this.disableFields)
			setTimeout(() => {
				this.formComponent.formio.component.properties = {
					...this.formComponent.formio.component.properties,
					disabled: false,
					excludedFields: this.disableFields,
				};
				this.formComponent.disableCurrentForms();
			}, 250);

		this.onFormLoad.emit();
	}

	submit(submission) {
		this.onSubmit.emit(submission.submission);
	}

	change(submission) {
		this.onChange.emit(submission);
	}
	customEvent(event) {
		this.onCustomEvent.emit({ type: event.type, data: event.data, formComponent: this.formComponent });
	}
	beforeSubmit(event) {
		this.onBeforeSubmit.emit(event);
	}
}
